export default __webpack_public_path__ + "static/media/danger.6a48ff56.svg";